import { getAuth } from 'firebase/auth';

/**
 * Get the current user's Firebase ID token
 * @returns ID token string or null if not authenticated
 */
export async function getAuthToken(): Promise<string | null> {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.warn('[Auth] No current user found');
      return null;
    }
    return await currentUser.getIdToken();
  } catch (error) {
    console.error('[Auth] Error getting auth token:', error);
    return null;
  }
}

/**
 * Get Authorization header with Bearer token for API requests
 * @returns Object with Authorization header or empty object if not authenticated
 */
export async function getAuthHeader(): Promise<Record<string, string>> {
  const token = await getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
